function tableObserver(): void {
  document.querySelectorAll('table.rbb-table-responsive-sm, table.rbb-table-responsive-md, table.rbb-table-responsive-lg, table.rbb-table-responsive-xl').forEach((responsiveTable) => {
    const responsiveTableHeadRow = responsiveTable.querySelector('thead tr');
    responsiveTable.querySelectorAll('tbody tr').forEach((responsiveTableBodyRow) => {
      for (let i = 0; i < responsiveTableBodyRow.children.length; i++) {
        if (responsiveTableHeadRow && (responsiveTableHeadRow.children[i] as HTMLElement | undefined)?.innerText) {
          responsiveTableBodyRow.children[i].setAttribute('data-label', (responsiveTableHeadRow.children[i] as HTMLElement).innerText);
        } else {
          responsiveTableBodyRow.children[i].removeAttribute('data-label');
        }
      }
    });
  });

  document.querySelectorAll('th:empty:not([aria-hidden])').forEach(
    emptyTableHeader => emptyTableHeader.ariaHidden = 'true'
  );

  document.querySelectorAll(':not(.scroll-wrapper) > table.table').forEach(
    (table) => {
      let scrollExists = false;
      let e = table.parentElement;
      while (e && e.tagName !== 'DIV' && e.parentElement) {
        e = e.parentElement;
      }
      e?.classList?.forEach(
        (className) => {
          if (className.includes('scroll')) {
            scrollExists = true;
          }
        }
      );
      if (!scrollExists) {
        const scrollWrapper = document.createElement('div');
        scrollWrapper.classList.add('scroll-wrapper');
        table.parentElement?.insertBefore(scrollWrapper, table);
        scrollWrapper.appendChild(table);
        scrollWrapper.style.marginBottom = getComputedStyle(table).marginBottom;
        (table as HTMLTableElement).style.marginBottom = '0';
      }
    }
  );

  document.querySelectorAll('.scroll-wrapper').forEach((scrollWrapper) => {
    if (!scrollWrapper.children.length) {
      scrollWrapper.remove();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  tableObserver();
  new MutationObserver(tableObserver).observe(document, { childList: true, subtree: true });
});
